<template>
    <div v-if="show" class="modal show" role="modal">
        <div class="modal-backdrop show" style="z-index: unset" @mousedown="close"></div>
        <div class="modal-dialog modal-lg popup">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">
                        {{ this.eventValues.date }}
                    </div>
                    <button type="button" class="close" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="d-flex align-items-start justify-content-between mb-3">
                        <h4>{{ trans('Planned tasks') }}</h4>
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="openPlanningFormForNew"
                        >
                            {{ trans('schedule') }}
                            <i class="icofont-plus"></i>
                        </button>
                    </div>

                    <div v-for="(slot, index) in slots" :key="index" class="row my-1">
                        <div class="col-12">
                            <div class="fieldset-wrap">
                                <fieldset class="fieldset selected-task-div">
                                    <legend>
                                        {{ slot.date_start }}
                                        <span v-if="slot.date_start !== slot.date_end">
                                            - {{ slot.date_end }}
                                        </span>
                                    </legend>
                                    <div class="fieldset__buttons">
                                        <button
                                            class="btn btn-primary"
                                            @click="openPlanningFormForSlot(slot.id)"
                                        >
                                            <i class="icofont-ui-edit"></i>
                                        </button>
                                        <button
                                            class="btn btn-secondary"
                                            @click="confirmSlotDelete(slot)"
                                        >
                                            <i class="icofont-trash"></i>
                                        </button>
                                    </div>
                                    <div class="row">
                                        <div class="col-2">
                                            <div>
                                                {{ slot.time_start }} - {{ slot.time_end }}<br />
                                            </div>
                                        </div>
                                        <div class="col-2 d-flex flex-column">
                                            <span v-if="slot.assigned_persons.length">
                                                <i class="icofont-user"></i>
                                                {{ slot.assigned_persons.length }}
                                            </span>
                                            <span v-if="Object.keys(slot.assigned_teams).length">
                                                <i class="icofont-people"></i>
                                                {{ Object.keys(slot.assigned_teams).length }}
                                            </span>
                                            <span v-if="slot.repeated_settings_id">
                                                <i class="icofont-retweet"></i>
                                            </span>
                                        </div>
                                        <div class="col-8">
                                            <div>
                                                <i class="icofont-tasks-alt"></i>
                                                {{ slot.task_title }}
                                                <span
                                                    class="badge-round round-sm"
                                                    :style="{
                                                        backgroundColor: slot.task_status_color,
                                                    }"
                                                ></span>
                                            </div>
                                            <div v-if="slot.project">
                                                <i class="icofont-chart-flow-2"></i>
                                                {{ slot.project.title }}
                                            </div>
                                            <div v-if="slot.client">
                                                <i
                                                    v-if="slot.client.type === 'company'"
                                                    class="icofont-building-alt"
                                                ></i>
                                                <i
                                                    v-if="slot.client.type === 'contact'"
                                                    class="icofont-user-alt-3"
                                                ></i>
                                                {{ slot.client.title }}
                                            </div>

                                            <div
                                                class="d-flex flex-column"
                                                v-if="slot.task_location"
                                            >
                                                <span class="d-flex align-items-center">
                                                    <i class="icofont-location-pin"></i>
                                                    <span class="d-flex flex-column ml-1">
                                                        <span>
                                                            {{
                                                                slot.task_location.street +
                                                                ' ' +
                                                                slot.task_location.number
                                                            }}
                                                            <span v-if="slot.task_location.bus">
                                                                {{ slot.task_location.bus }}
                                                            </span>
                                                            <span class="text-nowrap">
                                                                {{ slot.task_location.zip }}&nbsp;{{
                                                                    slot.task_location.city
                                                                }}
                                                            </span>
                                                        </span>

                                                        <span>
                                                            {{ slot.task_location.country }}
                                                        </span>
                                                    </span>
                                                </span>
                                            </div>
                                            <div v-else><i class="icofont-location-pin"></i> -</div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <confirmation-modal-component
            v-if="confirmationModal.active"
            :body="confirmationModal.body"
            :subtitle="confirmationModal.subtitle"
            @close="confirmationModal.active = false"
            @succes="deleteSlot(confirmationModal.slot)"
        ></confirmation-modal-component>
        <update-repeated-slots-component
            v-if="updateRepeatedSlotsModal.active"
            :slot_id="updateRepeatedSlotsModal.slot_id"
            :all_update_option="updateRepeatedSlotsModal.all_update_option"
            @close="updateRepeatedSlotsModal.active = false"
            @update="deleteRepeatedSlots"
        ></update-repeated-slots-component>
    </div>
</template>

<script>
import { emitter } from '../../../plugins/Mitt';
import { mapState } from 'vuex';
import UpdateRepeatedSlotsComponent from '../../schedule/widgets/UpdateRepeatedSlotsComponent';

function inialState() {
    return {
        // The values passed by the event. The object is overwritten
        eventValues: {
            // All possible values
            personId: null,
            teamId: null,
            date: null,
        },
        slots: [],
    };
}
export default {
    components: {
        UpdateRepeatedSlotsComponent,
    },
    data() {
        return {
            ...inialState(),
            show: false,
            confirmationModal: {
                active: false,
                body: '',
                header: '',
                slot: null,
            },
            updateRepeatedSlotsModal: {
                active: false,
                slot: null,
                all_update_option: false,
            },
            optionConfirmedRepeatedSlotsInModal: false,
            updateRepeatedSlotSetting: '',
        };
    },
    computed: {
        ...mapState('planning', ['mode']),
    },
    methods: {
        close() {
            this.show = false;
            Object.assign(this.$data, inialState());
            emitter.off('planning-slots-changed', this.refreshOnSlotsChanged);
        },
        refreshOnSlotsChanged() {
            this.getDayInfo();
        },
        getDayInfo() {
            this.getSlots();
        },
        getSlots() {
            const params = {
                date: this.eventValues.date,
                itemId: this.eventValues.personId,
                mode: this.mode,
            };

            axios
                .get(route('capacity.get-day-detail-info'), { params: params })
                .then((response) => {
                    this.slots = response.data;
                });
        },
        openPlanningFormForSlot(slotId) {
            emitter.emit('open-planning-form', { slotId });
        },
        openPlanningFormForNew() {
            let eventObject = {
                dateStart: this.eventValues.date,
                dateEnd: this.eventValues.date,
                timeStart: '08:00', // TODO
                timeEnd: '16:00', // TODO
            };

            const mode = this.mode;

            if (mode === 'capacityPerson') {
                eventObject.personId = this.eventValues.personId;
            } else if (mode === 'capacityTeam') {
                eventObject.teamId = this.eventValues.teamId;
            }

            emitter.emit('open-planning-form', eventObject);
        },
        confirmSlotDelete(slot) {
            this.confirmationModal.active = true;
            this.confirmationModal.subtitle = trans('Watch out');
            this.confirmationModal.body = trans('Are you sure you want to delete this slot?');
            this.confirmationModal.slot = slot;
        },
        deleteSlot(slot) {
            this.confirmationModal.active = false;

            // Repeated slots
            if (slot.repeated_settings_id && !this.optionConfirmedRepeatedSlotsInModal) {
                this.updateRepeatedSlotsModal.active = true;
                this.updateRepeatedSlotsModal.slot = slot;
                return;
            }
            const slotId = slot.id;
            const url = route('planning.delete-slots', slotId);
            axios
                .delete(url, {
                    data: {
                        updateRepeatedSlotSetting: this.updateRepeatedSlotSetting,
                    },
                })
                .then((response) => {
                    emitter.emit('planning-slots-changed', response.data);
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        const errorMessage = trans("You don't have rights for this project");
                        emitter.emit('hide-slot-hover-info');
                        emitter.emit('hide-day-hover-info');
                        emitter.emit('show-message-modal', {
                            messageHtml: errorMessage,
                        });
                    }
                });

            if (this.optionConfirmedRepeatedSlotsInModal) {
                this.optionConfirmedRepeatedSlotsInModal = false;
                this.updateRepeatedSlotSetting = null;
                this.updateRepeatedSlotsModal.slot = null;
            }
        },
        deleteRepeatedSlots(value) {
            console.log(value);
            this.updateRepeatedSlotSetting = value;
            this.optionConfirmedRepeatedSlotsInModal = true;
            this.updateRepeatedSlotsModal.active = false;
            this.deleteSlot(this.updateRepeatedSlotsModal.slot);
        },
    },
    mounted() {
        emitter.on('open-planning-date-details', (eventValues) => {
            emitter.emit('hide-slot-hover-info');
            emitter.emit('hide-day-hover-info');
            emitter.emit('hide-context-menu-component');

            this.loading = true;
            this.eventValues = eventValues;
            this.getDayInfo();
            this.show = true;

            emitter.off('planning-slots-changed', this.refreshOnSlotsChanged);
            emitter.on('planning-slots-changed', this.refreshOnSlotsChanged);
        });
    },
    beforeUnmount() {
        emitter.off('planning-slots-changed', this.refreshOnSlotsChanged);
    },
};
</script>
<style lang="scss" scoped>
.fieldset {
    margin: 10px 0px;
    padding: 10px;
    legend {
        left: -10px;
    }
    &__buttons {
        top: -5px;
    }
}
</style>
